module.exports = __webpack_public_path__ + "a7822b4fb8e16b40a4654d251c2a66e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/unicase.png
// module id = 84
// module chunks = 0